import { render, staticRenderFns } from "./MyProjectsTabs.vue?vue&type=template&id=d9c0f556&scoped=true"
import script from "./MyProjectsTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyProjectsTabs.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MyProjectsTabs.vue?vue&type=style&index=0&id=d9c0f556&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c0f556",
  null
  
)

export default component.exports